module.exports = __webpack_public_path__ + "img/oelsnitz-ticket-logo-orange.6bc2fd02.png";